var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Plate_title",attrs:{"id":_vm.IdName ? '' : 'Plate_title'}},[_c('div',{staticClass:"text_title"},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('span',[_vm._t("title")],2)]),_c('div',{staticClass:"extra"},[_vm._t("extra")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }